import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { ClubDetailComponent } from "./club-detail-component/club.detail.component";
import { ClubsComponent } from "./clubs-component/clubs.component";
import { ConfirmClubComponent } from "./confirm-club-component/confirm.club.component";
import { UsersComponent } from "./users-component/users.component";
import { UserDetailComponent } from "./user-detail-component/user.detail.component";
import { PostsComponent } from "./posts-component/posts.component";
import { PostDetailComponent } from "./post-detail-component/post.detail.component";
import { PostEveryoneComponent } from "./post-everyone-component/post.everyone.component";
import { CreatePostEveryoneComponent } from "./create-post-everyone/create.post.everyone.component";
import { TournamentsComponent } from "./tournaments-component/tournaments.component";
import { AddTournamentNewComponent } from "./add-tournament-new/add.tournament.component";
import { UpdateTournamentComponent } from "./update-tournament/update.tournament.component";
import { TournamentDetailComponent } from "./tournament-detail-component/tournament.detail.component";
import { OffersComponent } from "./offers-component/offers.component";
import { OrdersComponent } from "./orders-component/orders.component";
import { TeeComponent } from "./tee-component/tee.component";
import { AddHolesComponent } from "./add-holes-component/add.holes.component";
import { TermConditionComponent } from "./term-condition-component/term.condition.component";
import { PrivatePolicyComponent } from "./private-policy-component/private.policy.component";
import { AppVersionComponent } from "./app-version-component/app.version.component";
import { BankComponent } from "./bank-component/bank.component";
import { AttachmentsComponent } from "./attachments-component/attachments.component";
import { CompanyDetailComponent } from "./company-detail-component/company.detail.component";
import { InsightComponent } from "./insight/insight-component/insight.component";
import { PaymentsListComponent } from "./payments-list-component/payments-list.component";
import { ChangePasswordComponent } from "./change-password-component/change.password.component";
import { ScorecardsComponent } from "./scorecards-component/scorecards.component";
import { OfferDetailComponent } from "./offer-detail-component/offer.detail.component";
import { CreateOfferComponent } from "./create-offer-component/create.offer.component";
import { CreateEventComponent } from "./create-event-component/create.event.component";

import { OrderDetailComponent } from "./order-detail-component/order.detail.component";
import { UpdateOfferComponent } from "./update-offer/update.offer.component";
import { ClubSubscriptionsComponent } from "./club-subscriptions-component/club.subscriptions.component";
import { ClubSubscriptionDetailComponent } from "./club-subscription-detail-component/club.subscription.detail.component";
import { ClubScorecardsComponent } from "./club-scorecards-component/club.scorecards.component";
import { CourseComponent } from "./course-component/course.component";
import { EntryNotificationComponent } from "./entry-notification-component/entry.notification.component";
import { CompanyComponent } from "./company-component/company.component";
import { AddLeagueComponent } from "./add-league-component/add.league.component";
import { LeaguesComponent } from "./leagues-component/leagues.component";
import { LeagueDetailComponent } from "./league-detail-component/league-detail.component";
import { UpdateLeagueComponent } from "./update-league-component/update.league.component";
import { TeeTimeBookingComponent } from "./tee-time-booking-component/tee-time-booking.component";
import { PermissionComponent } from "./../directives/permission/permission.component";
import { ClubProfileComponent } from "./club-profile-component/profile.component";
import { CompanyProfileComponent } from "./company-profile-component/profile.component";
import { FollowersComponent } from "./followers-component/followers.component";
import { ClubInsightComponent } from "./insight/club-insight-component/insight.component";
import { CompanyInsightComponent } from "./insight/company-insight-component/insight.component";
import { ZestMappingComponent } from "./zest-course-mapping-component/zest-mapping.component";
import { NotificationComponent } from "./notification-component/notification.component";
import { CommunityDashboardComponent } from "./community-dashboard/community-dashboard.component";
import { AdvertisementComponent } from "./advertisement-component/advertisement.component";
import { PostReportComponent } from "./post-report-component/post-report.component";
import { PrioritiesComponent } from "./priorities-component/priorities.component";
import { SocialDashboardComponent } from "./social-dashboard/social-dashboard.component";
import { PlayDashboardComponent } from "./play-dashboard/play-dashboard.component";
import { ProshopDashboardComponent } from "./proshop-dashboard/proshop-dashboard.component";
import { GeneralDashboardComponent } from "./general-dashboard/general-dashboard.component";
import { ClubProfileSubmenuComponent } from "./club-profile-submenu-component/club-profile-submenu.component";
import { CompanyProfileSubmenuComponent } from "./company-porfile-submenu-component/company-profile-submenu.component";
import { InsightsManagerComponent } from "./insights-manager/insights-manager.component";
import { RoleManagerComponent } from "./role-manager-component/role-manager-component";
import { BirdietimeIntegrationComponent } from "./birdietime-integration-component/birdietime-integration.component";
import { HubberProIntegrationComponent } from "./hubber-pro-integration-component/hubber-pro-integration.component";
import { LiveScoringComponent } from "./live-scoring-component/live-scoring.component";
import { HubberPracticeComponent } from "./hubber-practice-component/hubber-practice.component";
import { SocietyComponent } from "./society/society-component/society.component";
import { SocietyProfileSubmenuComponent } from "./society/society-profile-submenu-component/society-profile-submenu.component";
import { ClubMembersComponent } from "./club-members-component/club.members.component";
import { TourComponent } from "./tour/tour-component/tour.component";
import { TourProfileSubmenuComponent } from "./tour/tour-profile-submenu-component/tour-profile-submenu.component";
import { FollowerRequestComponent } from "./follower-request-component/follower-request.component";
import { PortfolioDashboardComponent } from "./portfolio-dashboard/portfolio-dashboard.component";
import { ProfileDashboardComponent } from "./profile-dashboard/profile-dashboard.component";
import { MyFollowersComponent } from "./my-followers-component/my-followers.component";
import { MyInsightsComponent } from "./my-insights-component/my-insights.component";
import { GhMobileAppComponent } from "./GH-mobile-app-component/gh-mobile-app-.component";
import { ClubPackageComponent } from "./club-package-component/club-package.component";
import { TournamentsMatchplayDetailsComponent } from "./tournaments-matchplay-details/tournaments-matchplay-details.component";
import {
  CanDeactivateGuard,
  RouteAuthGuardService,
  AdminRouteAuthGuardService
} from "app/services/auth-guard";
import { EditPostComponent } from "./edit-post-component/edit.post.component";
import { TotalActiveComponiesComponent } from "./total-active-companies/total-active-companies.component";
import { AllPostsComponent } from "./all-posts-component/all-posts.component";
import { AppUsersComponent } from "./app-users/app-users.component";
import { EditLeaderboardComponent } from "./edit-leaderboard-component/edit-leaderboard.component";
import { EventsComponent } from "./events-component/events.component";
import { EventDetailComponent } from "./event-details-component/event.detail.component";
import { UpdateEventComponent } from "./update-event-details-component/update.event.component";
import { EffectiveTournamentsComponent } from "./effective-tournaments-components/effective-tournaments.component";
import { WebsiteEnquiriesComponent } from "./website-enquiries/website-enquiries.component";
import { MultiRoundComponent } from "./multi-round/multi-round.component";
import { CreateMultiRoundTournamentComponent } from "./create-multi-round-tournament/create-multi-round-tournament.component";
import { MultiroundTournamentDetailComponentComponent } from "./multiround-tournament-detail-component/multiround-tournament-detail-component.component";
import { CreatorDetailComponentComponent } from "./creator-detail-component/creator-detail-component.component";
import { CreatePrizeListComponent } from "./create-prize-list/create-prize-list.component";
import { UpdateMultiRoundTournamentComponent } from "./update-multi-round-tournament/update-multi-round-tournament.component";
import { RaffleComponent } from "./raffle-component/raffle-component.component";
import { UpdateRaffleComponent } from "./update-raffle/update-raffle.component";
import { CreateRaffleComponent } from "./create-raffle/create-raffle.component";
import { RaffleDetailComponent } from "./raffle-detail/raffle-detail.component";
import { RaffleOrderDetailComponent } from "./raffle-order-detail/raffle-order-detail.component";

const routes: Routes = [
  {
    path: "",
    data: {
      title: "",
    },
    children: [
      {
        path: "club-profile",
        component: ClubProfileComponent,
        data: {
          title: "Club Profile",
          appPermission: "profile",
          operation: "read",
        },
        canActivate: [RouteAuthGuardService],
      },
      // {
      //   path: "post-report",
      //   component: PostReportComponent,
      //   data: {
      //     title: "Post Report",
      //   },
      // },
      {
        path: "notifications",
        component: NotificationComponent,
        data: {
          title: "Courses",
          appPermission: "notifications",
          operation: "read",
        },
        canActivate: [RouteAuthGuardService],
      },
      {
        path: "creator-details/:id",
        component: CreatorDetailComponentComponent,
        data: {
          title: "Tournaments",
          appPermission: "tournaments",
          operation: "read",
        },
        canActivate: [RouteAuthGuardService],
      },
      // {
      //   path: "my-followers",
      //   component: MyFollowersComponent,
      //   data: {
      //     title: "My Followers",
      //   },
      // },
      {
        path: "create-prize-list/:tournamentId/:noOfPositions",
        component: CreatePrizeListComponent,
        data: {
          title: "My Followers",
          appPermission: "tournaments",
          operation: "create",
        },
        canActivate: [RouteAuthGuardService],
      },
      {
        path: "my-insights",
        component: MyInsightsComponent,
        data: {
          title: "My Followers",
          appPermission: "reports",
          operation: "read",
        },
        canActivate: [RouteAuthGuardService],
      },
      {
        path: "community-dashboard",
        component: CommunityDashboardComponent,
        data: {
          title: "Community-dashboard",
          appPermission: "community",
          operation: "read",
        },
        canActivate: [RouteAuthGuardService],
      },
      {
        path: "profile-dashboard",
        component: ProfileDashboardComponent,
        data: {
          title: "Profile-dashboard",
          appPermission: "profile",
          operation: "read",
        },
        canActivate: [RouteAuthGuardService],
      },
      {
        path: "portfolio-dashboard",
        component: PortfolioDashboardComponent,
        data: {
          title: "Portfolio Dashboard",
          appPermission: "portfolio",
          operation: "read",
        },
        canActivate: [RouteAuthGuardService],
      },
      {
        path: "ClubSubscriptions",
        component: ClubSubscriptionsComponent,
        data: {
          title: "Club Subscriptions",
          appPermission: "club-subscriptions",
          operation: "read",
        },
      },
      {
        path: "general-dashboard",
        component: GeneralDashboardComponent,
        data: {
          title: "general-dashboard",
          appPermission: "general",
          operation: "read",
        },
        canActivate: [RouteAuthGuardService],
      },

      {
        path: "social-dashboard",
        component: SocialDashboardComponent,
        data: {
          title: "social-dashboard",
          appPermission: "posts",
          operation: "read",
        },
        canActivate: [RouteAuthGuardService],
      },
      {
        path: "play-dashboard",
        component: PlayDashboardComponent,
        data: {
          title: "play-dashboard",
          appPermission: "play",
          operation: "read",
        },
        canActivate: [RouteAuthGuardService],
      },
      {
        path: "proshop-dashboard",
        component: ProshopDashboardComponent,
        data: {
          title: "proshop-dashboard",
          appPermission: "pro_shop",
          operation: "read",
        },
        canActivate: [RouteAuthGuardService],
      },
      {
        path: "follow-request",
        component: FollowerRequestComponent,
        data: {
          title: "Society Profile",
          appPermission: "followers_request",
          operation: "read",
        },
        canActivate: [RouteAuthGuardService],
      },
      {
        path: "advertisements",
        component: AdvertisementComponent,
        data: {
          title: "Advertisements",
          appPermission: "advertisements",
          operation: "read",
        },
        canActivate: [RouteAuthGuardService],
      },
      {
        path: "company-profile",
        component: CompanyProfileComponent,
        data: {
          title: "Company-profile",
          appPermission: "profile",
          operation: "read",
        },
        canActivate: [RouteAuthGuardService],
      },
      {
        path: "courses/:id",
        component: CourseComponent,
        data: {
          title: "Courses",
          appPermission: "courses",
          operation: "read",
        },
        canActivate: [RouteAuthGuardService],
      },
      {
        path: "club-insight",
        component: ClubInsightComponent,
        data: {
          title: "Courses",
        },
      },
      {
        path: "company-insight",
        component: CompanyInsightComponent,
        data: {
          title: "Courses",
        },
      },
      {
        path: "tee/:id/:club",
        component: TeeComponent,
        data: {
          title: "Tees",
        },
      },
      {
        path: "followers",
        component: FollowersComponent,
        data: {
          title: "Followers",
          appPermission: "followers",
          operation: "read",
        },
        canActivate: [RouteAuthGuardService],
      },
      {
        path: "members",
        component: ClubMembersComponent,
        data: {
          title: "Members",
          appPermission: "members",
          operation: "read",
        },
        canActivate: [RouteAuthGuardService],
      },
      {
        path: "addTee/:id/:club",
        component: AddHolesComponent,
        data: {
          title: "Add Tee",
        },
      },
      // {
      //   path: "confirmClubs",
      //   component: ConfirmClubComponent,
      //   data: {
      //     title: "Confirm Clubs",
      //   },
      // },
      // {
      //   path: "clubs",
      //   component: ClubsComponent,
      //   data: {
      //     title: "Clubs",
      //   },
      // },
      {
        path: "clubs/:id",
        component: ClubDetailComponent,
        data: {
          title: "Club Detail",
        },
      },

      {
        path: "ClubSubscriptionDetail/:id",
        component: ClubSubscriptionDetailComponent,
        data: {
          title: "Club Subscription Detail",
        },
      },
      {
        path: "users",
        component: UsersComponent,
        data: {
          title: "Users",
          appPermission: "dashboard-users",
          operation: "read",
        },
        canActivate: [AdminRouteAuthGuardService],
      },
      {
        path: "userDetail/:id/:ismember",
        component: UserDetailComponent,
        data: {
          title: "User Detail",
        },
      },

      {
        path: "posts",
        component: PostEveryoneComponent,
        data: {
          title: "Admin Posts",
          appPermission: "my_post",
          operation: "read",
        },
        canActivate: [RouteAuthGuardService],
      },
      {
        path: "all-posts",
        component: AllPostsComponent,
        data: {
          title: "All Posts",
          appPermission: "all_post",
          operation: "read",
        },
        canActivate: [RouteAuthGuardService],
      },
      {
        path: "postDetail/:author/:id",
        component: PostDetailComponent,
        data: {
          title: "Post Detail",
        },
      },
      {
        path: "update-post/:author/:id",
        component: EditPostComponent,
        data: {
          title: "Post Detail",
        },
      },
      {
        path: "postToEveryone",
        component: PostEveryoneComponent,
        data: {
          title: "Admin Posts",
          appPermission: "my_post",
          operation: "read",
        },
        canActivate: [RouteAuthGuardService],
      },
      {
        path: "createPostEveryone",
        component: CreatePostEveryoneComponent,
        data: {
          title: "Create Post To Everyone",
          appPermission: "my_post",
          operation: "create",
        },
        canActivate: [RouteAuthGuardService],
      },
      {
        path: "tournaments",
        component: TournamentsComponent,
        canActivate: [RouteAuthGuardService],
        data: {
          title: "Tournaments",
          appPermission: "tournaments",
          operation: "read",
        },
      },
      {
        path: "tournamentDetail/:id",
        component: TournamentDetailComponent,
        data: {
          title: "Tournament Detail",
        },
      },
      {
        path: "tournamentDetail/:id/:pageNumber",
        component: TournamentDetailComponent,
        data: {
          title: "Tournament Detail",
        },
      },
      {
        path: "tournamentDetail-multiround/:id",
        component: MultiroundTournamentDetailComponentComponent,
        data: {
          title: "Tournament Detail",
        },
      },
      {
        path: "tournamentDetail-multiround/:id/:pageNumber",
        component: MultiroundTournamentDetailComponentComponent,
        data: {
          title: "Tournament Detail",
        },
      },
      {
        path: "entry-notification/:id",
        component: EntryNotificationComponent,
        data: {
          title: "Entry Notification",
        },
      },
      {
        path: "tournamentUpdate/:id",
        component: UpdateTournamentComponent,
        data: {
          title: "Add Tournament",
        },
      },
       {
        path: "edit-multiround/:id",
        component: UpdateMultiRoundTournamentComponent,
        data: {
          title: "Add Tournament",
        },
      },
      {
        path: "addTournamentNew",
        component: AddTournamentNewComponent,
        data: {
          title: "Add Tournament",
          appPermission: "tournaments",
          operation: "create",
        },
        canActivate: [RouteAuthGuardService],
      },
      {
        path: "addMultiroundTournament",
        component: CreateMultiRoundTournamentComponent,
        data: {
          title: "Add Tournament",
          appPermission: "tournaments",
          operation: "create",
        },
        canActivate: [RouteAuthGuardService],
      },
      {
        path: "vouchers",
        component: OffersComponent,
        data: {
          title: "Vouchers",
          appPermission: "voucher",
          operation: "read",
        },
        canActivate: [RouteAuthGuardService],
      },
      {
        path: "events",
        component: EventsComponent,
        data: {
          title: "Events",
          appPermission: "events",
          operation: "read",
        },
        canActivate: [AdminRouteAuthGuardService],
      },
       {
        path: "raffle",
        component: RaffleComponent,
        data: {
          title: "Raffle",
          appPermission: "events",
          operation: "read",
        },
        canActivate: [AdminRouteAuthGuardService],
      },
      {
        path: "orders",
        component: OrdersComponent,
        data: {
          title: "All Orders",
          appPermission: "dashboard-orders",
          operation: "read",
        },
        canActivate: [AdminRouteAuthGuardService],
      },
      {
        path: "createVoucher",
        component: CreateOfferComponent,
        data: {
          title: "Create Voucher",
          appPermission: "voucher",
          operation: "create",
        },
        canActivate: [RouteAuthGuardService],
      },
      {
        path: "createEvent",
        component: CreateEventComponent,
        data: {
          title: "Create Voucher",
        },
      },
      {
        path: "createRaffle",
        component: CreateRaffleComponent,
        data: {
          title: "Create Raffle",
        },
      },
      {
        path: "updateVoucher/:author/:id",
        component: UpdateOfferComponent,
        data: {
          title: "Update Voucher",
          appPermission: "voucher",
          operation: "update",
        },
        canActivate: [RouteAuthGuardService],
      },
      {
        path: "updateEvent/:author/:id",
        component: UpdateEventComponent,
        data: {
          title: "Update Voucher",
        },
      },
      {
        path: "updateRaffle/:id",
        component: UpdateRaffleComponent,
        data: {
          title: "Update Raffle",
        },
      },
      {
        path: "voucherDetail/:author/:id",
        component: OfferDetailComponent,
        data: {
          title: "Voucher Detail",
          appPermission: "voucher",
          operation: "read",
        },
        canActivate: [RouteAuthGuardService],
      },
      {
        path: "eventDetail/:author/:id",
        component: EventDetailComponent,
        data: {
          title: "Event Detail",
        },
      },
       {
        path: "raffleDetail/:id",
        component: RaffleDetailComponent,
        data: {
          title: "Raffle Detail",
        },
      },
      {
        path: "changePassword",
        component: ChangePasswordComponent,
        data: {
          title: "Change Password",
        },
      },
      {
        path: "orderDetail/:offerKey/:orderKey",
        component: OrderDetailComponent,
        data: {
          title: "Order Detail",
        },
      },
      {
        path: "raffleOrderDetail/:raffleId/:userId/:orderId",
        component: RaffleOrderDetailComponent,
        data: {
          title: "Raffle Order Detail",
        },
      },
      {
        path: "termsAndConditions",
        component: TermConditionComponent,
        data: {
          title: "Terms and Conditions",
        },
      },
      {
        path: "privatePolicy",
        component: PrivatePolicyComponent,
        data: {
          title: "Private Policy",
        },
      },
      {
        path: "appVersion",
        component: AppVersionComponent,
        data: {
          title: "Latest App Version",
        },
      },
      {
        path: "bank",
        component: BankComponent,
        data: {
          title: "Bank Details",
          appPermission: "manage_stripe",
          operation: "read",
        },
        canActivate: [RouteAuthGuardService],
      },
      {
        path: "attachments",
        component: AttachmentsComponent,
        data: {
          title: "Attachments List",
        },
      },
      {
        path: "scorecards",
        component: ScorecardsComponent,
        data: {
          title: "Scorecards count List",
        },
        canActivate: [AdminRouteAuthGuardService],
      },
      {
        path: "scorecards/:id",
        component: ClubScorecardsComponent,
        data: {
          title: "Scorecards count List",
          appPermission: "dashboard-scorecards",
          operation: "read",
        },
        canActivate: [RouteAuthGuardService],
      },
      {
        path: "insights",
        component: InsightComponent,
        data: {
          title: "Insights",
        },
        canActivate:[AdminRouteAuthGuardService],
      },
      {
        path: "company",
        component: CompanyComponent,
        data: {
          title: "Company List",
        },
      },
      {
        path: "company/:id",
        component: CompanyDetailComponent,
        data: {
          title: "Company Detail",
        },
        canDeactivate: [CanDeactivateGuard],
      },

      {
        path: "tour/:id",
        component: CompanyDetailComponent,
        data: {
          title: "Company Detail",
        },
        canDeactivate: [CanDeactivateGuard],
      },

      // {
      //   path: "leagues",
      //   component: LeaguesComponent,
      //   data: {
      //     title: "Leagues",
      //   },
      // },
      // {
      //   path: "leagues/create",
      //   component: AddLeagueComponent,
      //   data: {
      //     title: "Create League",
      //   },
      // },
      // {
      //   path: "leagues/:id",
      //   component: LeagueDetailComponent,
      //   data: {
      //     title: "League Detail",
      //   },
      // },
      // {
      //   path: "leagues/update/:id",
      //   component: UpdateLeagueComponent,
      //   data: {
      //     title: "League Detail",
      //   },
      // },

      {
        path: "tee-time-booking",
        component: TeeTimeBookingComponent,
        data: {
          title: "Tee Time Booking",
          appPermission: "tee_time",
          operation: "read",
        },
        canActivate: [RouteAuthGuardService],
      },
      {
        path: "master-permissions",
        component: PermissionComponent,
        data: {
          title: "Permission",
        },
      },
      {
        path: "club-mapping",
        component: ZestMappingComponent,
        data: {
          title: "Permission",
          appPermission: "club_mapping",
          operation: "read",
        },
        canActivate: [RouteAuthGuardService],
      },
      {
        path: "subscription",
        component: PaymentsListComponent,
        data: {
          title: "Permission",
          appPermission: "subscriptions",
          operation: "read",
        },
        canActivate: [RouteAuthGuardService],
      },
      {
        path: "priorities",
        component: PrioritiesComponent,
        data: {
          title: "Priorities",
          appPermission: "priority",
          operation: "read",
        },
        canActivate: [RouteAuthGuardService],
      },
      {
        path: "club-profile-submenu",
        component: ClubProfileSubmenuComponent,
        data: {
          title: "Club Profile",
          // appPermission: "dashboard-club-profile-submenu",
          // operation: "read",
        },
        canActivate: [AdminRouteAuthGuardService],
      },

      {
        path: "company-profile-submenu",
        component: CompanyProfileSubmenuComponent,
        data: {
          title: "Company Profile",
          appPermission: "com",
          operation: "read",
        },
        canActivate: [RouteAuthGuardService],
      },
      {
        path: "total-active-companies",
        component: TotalActiveComponiesComponent,
        data: {
          title: "Active Componies",
          // appPermission: "dashboard-total-active-companies",
          // operation: "read",
        },
        canActivate: [AdminRouteAuthGuardService],
      },
      {
        path: "insights-manager",
        component: InsightsManagerComponent,
        data: {
          title: "Insights Manager",
          appPermission: "insight_manager",
          operation: "read",
        },
        canActivate: [AdminRouteAuthGuardService],
      },
      {
        path: "role-manager",
        component: RoleManagerComponent,
        data: {
          title: "Role Manager",
          // appPermission: "dashboard-role-manager",
          // operation: "read",
        },
        canActivate: [AdminRouteAuthGuardService],
      },
      {
        path: "birdietime-integration",
        component: BirdietimeIntegrationComponent,
        data: {
          title: "Birdietime Integraion",
        },
        canActivate: [AdminRouteAuthGuardService],
      },
      {
        path: "hubber-pro-integration",
        component: HubberProIntegrationComponent,
        data: {
          title: "Hubber Pro Integration",
          // appPermission: "dashboard-hubber-pro-integration",
          // operation: "read",
        },
        canActivate: [AdminRouteAuthGuardService],
      },
      {
        path: "live-scoring",
        component: LiveScoringComponent,
        data: {
          title: "Live Scoring",
        },
      },
      {
        path: "hubber-practice",
        component: HubberPracticeComponent,
        data: {
          title: "Hubber Practice",
        },
      },
      {
        path: "multi-round",
                component: MultiRoundComponent,

        // component: HubberPracticeComponent,
        data: {
          title: "Hubber Practice",
        },
      },
      {
        path: "golf-tour",
        component: HubberPracticeComponent,
        data: {
          title: "Hubber Practice",
        },
      },
      {
        path: "league",
        component: HubberPracticeComponent,
        data: {
          title: "Hubber Practice",
          appPermission: "leagues",
          operation: "read",
        },
        canActivate: [RouteAuthGuardService],
      },
      {
        path: "pros/:isPro",
        component: UsersComponent,
        data: {
          title: "Hubber Practice",
          // appPermission: "dashboard-pros",
          // operation: "read",
        },
        canActivate: [AdminRouteAuthGuardService],
      },
      {
        path: "amateurs/:isPro",
        component: UsersComponent,
        data: {
          title: "Hubber Practice",
          // appPermission: "dashboard-amateurs",
          // operation: "read",
        },
        canActivate: [AdminRouteAuthGuardService],
      },
      {
        path: "society",
        component: SocietyComponent,
        data: {
          title: "Society",
        },
      },
      {
        path: "society-profile-submenu",
        component: SocietyProfileSubmenuComponent,
        data: {
          title: "Society Profile",
        },
      },
      {
        path: "society-profile-submenu/:temp",
        component: SocietyProfileSubmenuComponent,
        data: {
          title: "Society Profile",
          // appPermission: "dashboard-society-profile-submenu",
          // operation: "read",
        },
        canActivate: [AdminRouteAuthGuardService],
      },
      {
        path: "tour",
        component: TourComponent,
        data: {
          title: "Tour",
        },
      },
      {
        path: "tour-profile-submenu",
        component: TourProfileSubmenuComponent,
        data: {
          title: "Tour Profile",
        },
      },
      {
        path: "tour-profile-submenu/:temp",
        component: TourProfileSubmenuComponent,
        data: {
          title: "Society Profile",
          // appPermission: "dashboard-tour-profile-submenu",
          // operation: "read",
        },
        canActivate: [AdminRouteAuthGuardService],
      },
      {
        path: "gh-mobile-app",
        component: GhMobileAppComponent,
        data: {
          title: "GH Mobile App",
          // appPermission: "dashboard-gh-mobile-app",
          // operation: "read",
        },
        canActivate: [AdminRouteAuthGuardService],
      },
      {
        path: "club-package",
        component: ClubPackageComponent,
        data: {
          title: "GH Mobile App",
          // appPermission: "dashboard-club-package",
          // operation: "read",
        },
        canActivate: [AdminRouteAuthGuardService],
      },
      {
        path: "tournaments-matchplay-details/:id",
        component: TournamentsMatchplayDetailsComponent,
        data: {
          title: "Matchplay details",
        },
      },
      {
        path: "tournaments-matchplay-details/:id/:tabindex",
        component: TournamentsMatchplayDetailsComponent,
        data: {
          title: "Matchplay details",
        },
      },

      {
        path: "marketing-material",
        component: ClubPackageComponent,
        data: {
          title: "GH Mobile App",
          // appPermission: "dashboard-marketing-material",
          // operation: "read",
        },
        canActivate: [AdminRouteAuthGuardService],
      },
      {
        path: "app-users",
        component: AppUsersComponent,
        data: {
          title: "App Users",
        },
      },
      {
        path: "effective-tournaments",
        component: EffectiveTournamentsComponent,
        data: {
          title: "Effect tournaments",
        },
      },
      {
        path: "website-enquiries",
        component: WebsiteEnquiriesComponent,
        data: {
          title: "Website Enquiries",
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ComponentsRoutingModule {}
